import { TvChannel } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

export interface ChannelWallpaperItem {
    contentId: string;
    title: string;
    logo: string | null;
}

function transformChannelData(channel: TvChannel): ChannelWallpaperItem {
    const logo = channel.logo?.toString() ?? '';

    return {
        contentId: channel.contentId,
        title: channel.title,
        logo,
    };
}

export function getChannelsWallpapers(channels: TvChannel[]): ChannelWallpaperItem[] {
    return channels.map(transformChannelData);
}
